import { all, delay, put } from 'redux-saga/effects';

import { selectWhen } from 'store/helpers';
import * as InsuranceAnketaActions from 'store/insuranceAnketa/actions';
import { backToFrontDriver } from 'store/insuranceAnketa/backToFrontMapper';
import * as InsuranceAnketaConstants from 'store/insuranceAnketa/constants';
import * as InsuranceAnketaSelectors from 'store/insuranceAnketa/selectors';

import * as InsuranceConstants from '../../constants';
import { aggregateCustomerIDsByRole, CreateStage } from '../../helpers';

const isValidCustomers = (customers) => {
  return Array.isArray(customers) && customers.length;
};

export const insuranceStageGetDriverCustomers = new CreateStage({
  action: InsuranceConstants.ACTIONS.GET_DRIVER_CUSTOMERS,
  before: function* () {
    yield delay(1000);
  },
  handler: function* () {
    const [roles, customers] = yield all([
      selectWhen(
        InsuranceAnketaSelectors.selectField(InsuranceAnketaConstants.FIELDS.CUSTOMER_ROLES),
        Boolean
      ),
      selectWhen(
        InsuranceAnketaSelectors.selectField(InsuranceAnketaConstants.FIELDS.FILLED_CUSTOMERS),
        isValidCustomers
      ),
    ]);

    const customersMap = customers.reduce((acc, { id, ...rest }) => {
      return { ...acc, [id]: { id, ...rest } };
    }, {});

    const {
      [InsuranceAnketaConstants.CUSTOMER_ROLES.DRIVER]: driverMap,
      [InsuranceAnketaConstants.CUSTOMER_ROLES.INSURER]: insurerMap,
      [InsuranceAnketaConstants.CUSTOMER_ROLES.OWNER]: ownerMap,
    } = aggregateCustomerIDsByRole({ roles });

    const drivers = Array.from(driverMap.keys()).map((id) => {
      return {
        ...backToFrontDriver({ customer: customersMap[id] }),
        [InsuranceAnketaConstants.DRIVER_FIELDS.ROLES]: [
          insurerMap.has(id) && InsuranceAnketaConstants.CUSTOMER_ROLES.INSURER,
          ownerMap.has(id) && InsuranceAnketaConstants.CUSTOMER_ROLES.OWNER,
        ].filter(Boolean),
      };
    });

    yield put(
      InsuranceAnketaActions.setBatchState({ [InsuranceAnketaConstants.FIELDS.DRIVERS]: drivers })
    );
  },
  name: InsuranceConstants.STAGES_FIELDS.GET_DRIVER_CUSTOMERS,
}).watcher;
